import html2canvas from 'html2canvas';

// Reusable browser-side PNG generation for the hidden offer share card.
export const generateAndDownloadOfferImage = async (element, offerTitle) => {
  if (!element) return;

  const canvas = await html2canvas(element, {
    useCORS: true,
    allowTaint: false,
    scale: 2,
    backgroundColor: null,
  });

  const link = document.createElement('a');
  link.download = `${offerTitle || 'عرض'}.png`;
  link.href = canvas.toDataURL('image/png');
  link.click();
};
